import CryptoTable from "./CryptoTable";
export default CryptoTable;
